// Balance = Σ(unpaid drink prices) + Σ(unpaid fees) − Σ(unused credits).
// A faithful port of drink-counter's balanceCalculation. Guest drinks are billed
// to the owning member (userId = member), so they are already included in the tab.

interface DrinkOnTab {
  paidAt?: number | null
  drink?: { priceCents: number } | null | undefined
}
interface FeeLike {
  paidAt?: number | null
  amountCents: number
}
interface CreditLike {
  usedAt?: number | null
  /** What is left to spend — a credit may be partially consumed (US-16). */
  remainingAmountCents: number
}

export function unpaidDrinksTotal(tab: readonly DrinkOnTab[]): number {
  return tab
    .filter((d) => d.paidAt == null)
    .reduce((sum, d) => sum + (d.drink?.priceCents ?? 0), 0)
}

export function unpaidFeesTotal(fees: readonly FeeLike[]): number {
  return fees.filter((f) => f.paidAt == null).reduce((sum, f) => sum + f.amountCents, 0)
}

export function unusedCreditsTotal(credits: readonly CreditLike[]): number {
  return credits
    .filter((c) => c.usedAt == null)
    .reduce((sum, c) => sum + c.remainingAmountCents, 0)
}

export function computeBalance(
  tab: readonly DrinkOnTab[],
  fees: readonly FeeLike[],
  credits: readonly CreditLike[],
): number {
  return unpaidDrinksTotal(tab) + unpaidFeesTotal(fees) - unusedCreditsTotal(credits)
}
